module.exports = __webpack_public_path__ + "static/media/company-profile-ad1.294acd82.jpg";